<template>
  <el-dialog :visible.sync="visible" width="80%" center @close="closeDialog">
    <div slot="title" class="dialog-title">
      <div class="go_0" @click="closeDialog">
        <i class="hy-icon-fanhui" style="color: #4e6ef2; font-size: 18px"></i>
        返回
      </div>
      <div class="title">关于”{{ title }}”的采购询价公告</div>
    </div>
    <div class="dialog_center">
      <div class="data">
        公示采购信息由新疆煤炭交易中心根据与相关单位的合作安排整理发布原始数据来源于合作方官方网站，具体内容以其官网发布为准。
      </div>
      <div class="img">
        <div class="content_all">
          <img
            style="width: 100%; height: 100%"
            :src="baseUrl + 'third/third/ossGetFile/' + imgUrl"
          />
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <div class="footer-text" v-if="bulletinLink">
        <el-checkbox v-model="checked" >
          我已阅读并接受以上询价公告所示内容
        </el-checkbox>
      </div>
      <div class="footer-text" v-if="bulletinLink">
        <el-checkbox v-model="checked1">
          我已注册成为公告所示终端的供应商
        </el-checkbox>
        <!-- &nbsp;&nbsp;&nbsp;
        <a href="https://scm.szecp.com.cn/scm/#/SupplierRegister">点击注册</a> -->
      </div>
      <div class="footer-text-btn">
        <el-button
          class="subimt_btn_inquiry"
          type="primary"
          plain
          v-if="regLink"
          @click="scmRegister"
          >点击注册供应商</el-button
        >
        <el-button
          class="subimt_btn_inquiry"
          type="primary"
          v-if="bulletinLink"
          @click="scmBulletinLink"
          :disabled="!checked || !checked1"
          >前往官网报名</el-button
        >
      </div>
    </span>
  </el-dialog>
</template>
<script>
const { baseUrl } = require("@/config");
export default {
  data() {
    return {
      baseUrl: baseUrl,
      checked: false,
      checked1: false,
      visible: false,
      imgUrl: "",
      bulletinLink: "",
      regLink:"",
      title: "",
    };
  },
  created() {},
  watch: {},
  methods: {
    scmBulletinLink() {
      if(this.bulletinLink.startsWith("http") || this.bulletinLink.startsWith("https")){
        window.open(this.bulletinLink, "_blank");
      }else{
        window.open('https://'+this.bulletinLink, "_blank");
      }
    },
    scmRegister() {
      if(this.regLink.startsWith("http") || this.regLink.startsWith("https")){
        window.open(this.regLink, "_blank");
      }else{
        window.open('https://'+this.regLink, "_blank");
      }
    },
    //window.open('https://scm.szecp.com.cn/scm/#/SupplierRegister')
    closeDialog() {
      this.imgUrl = "";
      this.title = "";
      this.bulletinLink = "";
      this.checked = false;
      this.visible = false;
      this.regLink = ""
    },
    openDialog(row) {
      console.log('openDialog',row);
      this.visible = true;
      this.imgUrl = row.attachmentUrl;
      this.title = row.purchaseName + row.goodsName;
      this.bulletinLink = row.bulletinLink;
      this.regLink = row.regLink
    },
  },
};
</script>
<style scoped lang="scss">
.dialog-title {
  position: relative;
  .title {
    font-weight: bold;
    font-size: 24px;
    text-align: center;
    line-height: 30px;
  }
  .go_0 {
    position: absolute;
    top: 0px;
    left: 10px;
    text-align: center;
    line-height: 30px;
    width: 90px;
    height: 34px;
    border: 1px solid #d2d2d2;
    border-radius: 17px;
    font-size: 14px;
    cursor: pointer;
  }
}
.dialog_center {
  width: 1200px;
  margin: 0 auto;
  background: #ffffff;

  .data {
    text-align: center;
    padding: 10px;
    background: #f3f3f7;
  }
}
.footer-text {
  line-height: 30px;
  width: 300px;
  margin: 0px auto;
  text-align: left;
}
.footer-text-btn {
  display: flex;
  justify-content: space-between;
  width: 350px;
  margin: 0px auto;
  

  .subimt_btn_inquiry {
    text-align: center;
    margin: 0px auto;
  }
}
</style>
